import { axiosInstance, requestConfig } from 'network/apis';

import { URL_BILLING } from "utils/constants";

export const callItemPayment = async (data) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, '/v2/payment/domestic', data));
};

export const callItemPaymentPayPalCreateOrder = async (data) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, '/v2/payment/international/createorder', data));
};

export const callItemPaymentPayPalOnApprove = async (orderID) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, `/v2/payment/international/${orderID}/capture/`));
};

export const callItemPaymentHistoryList = async (data) => {
    return await axiosInstance(requestConfig('get', URL_BILLING, `/v2/payment/shop/item/history`, data));
};

export const callItemPaymentTossCreateOrder = async (data) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, '/v3/payment/toss/createorder/shop', data));
};

export const callItemPaymentTossCaptureOrder = async (data) => {
    return await axiosInstance(requestConfig('post', URL_BILLING, '/v3/payment/toss/capture/shop', data));
};

export const callTossPaymentConfig = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/v3/payment/toss/config'));
};

export const callShippingAddress = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/v3/payment/shippingaddress'));
};